<template>
  <div class="left">
    <div class="head">存在以下特殊药品风险登记信息，请及时跟进处理：</div>
    <div v-for="(item, key) in list" :key="key" class="content">
      <div class="title left">
        登记单号 {{ item.registrationId }}
        <el-button type="text" @click="handleNavigateRegistration(item.registrationId)">（查看详情）</el-button>
      </div>
      <div>
        <div class="box-content">
          <div class="box-item">风险类型：</div>
          <span class="num color3">{{ item.riskList && item.riskList.join('、') }}</span>
        </div>
        <div>用药人：{{ item.patientName }} {{ item.patientSex | patientSex }} {{ item.patientAge }}岁</div>
        <!-- <div>
          登记药店：
          <span>{{ item.storeName }}</span>
        </div> -->
      </div>
    </div>
    <!-- <div class="bottom left">请及时跟进处理。</div> -->
  </div>
</template>

<script>
export default {
  props: ['list'],
  filters: {
    patientSex(val) {
      return { 1: '男', 0: '女' }[val] || val;
    }
  },
  methods: {
    handleNavigateRegistration(registrationId) {
      // register
      this.$emit('handleNavigateRegistration', registrationId);
    }
  }
};
</script>
<style lang="scss" scoped>
.head {
  font-size: 14px;
  margin-bottom: 24px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.content {
  color: #333;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 24px;
  // text-align: left;
}
.box-content {
  display: flex;
  max-width: 390px;
}
.box-item {
  min-width: 70px;
}
.num {
  font-weight: 600;
}
.color1 {
  color: #262626;
}
.color2 {
  color: #1e8dff;
}
.color3 {
  color: #ff4e47;
}
.left {
  text-align: left;
}
.color4 {
  color: #ff8200;
}
</style>
